/**
 * @generated SignedSource<<7bc300a6e8c2d0cfc625a05b0799f4d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanionContent_data$data = {
  readonly threads: {
    readonly edges: ReadonlyArray<{
      readonly __typename: "ThreadEdge";
    }>;
  };
  readonly wellbeingProfileResults: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "WellbeingProfileResult";
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"UpcomingEventsFragment_data">;
  readonly " $fragmentType": "CompanionContent_data";
};
export type CompanionContent_data$key = {
  readonly " $data"?: CompanionContent_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanionContent_data">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanionContent_data",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "UpcomingEventsFragment_data"
    },
    {
      "alias": null,
      "args": [
        (v1/*: any*/),
        {
          "kind": "Literal",
          "name": "type",
          "value": "WELLBEING"
        }
      ],
      "concreteType": "ThreadConnection",
      "kind": "LinkedField",
      "name": "threads",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ThreadEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": "threads(first:1,type:\"WELLBEING\")"
    },
    {
      "alias": null,
      "args": [
        {
          "fields": (v0/*: any*/),
          "kind": "ObjectValue",
          "name": "filterBy"
        },
        (v1/*: any*/)
      ],
      "concreteType": "WellbeingProfileResultConnection",
      "kind": "LinkedField",
      "name": "wellbeingProfileResults",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WellbeingProfileResult",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "f2d12f9bca1c24edd397a06e7c707d6e";

export default node;
